// HKDSE 十二篇範文測驗數據
export const hkdseQuizzes = [
  // A1. 孟子《魚我所欲也》
  {
    id: 'hkdse-quiz-a1-mengzi-fish',
    textId: 'hkdse-a1-mengzi-fish',
    title: '孟子《魚我所欲也》- 測驗',
    category: '議論散文',
    description: '測試對孟子捨生取義思想和論證手法的理解',
    difficulty: 'intermediate',
    totalQuestions: 12,
    timeLimit: 720, // 12 minutes
    questions: [
      {
        id: 1,
        question: '孟子在文中用魚和熊掌作比喻，主要是為了說明什麼？',
        type: 'multiple-choice',
        options: [
          '生活中的選擇困難',
          '道義比生存更重要',
          '物質享受的層次',
          '人的慾望無窮'
        ],
        correct: 1,
        explanation: '孟子以魚和熊掌分別比喻生存與道義，論證道義的價值比生存更高，從而引出捨生取義的道理。',
        points: 10
      },
      {
        id: 2,
        question: '文中「本心」指的是什麼？',
        type: 'multiple-choice',
        options: [
          '人的理性思考',
          '善良的道德本性',
          '個人的慾望',
          '社會的規範'
        ],
        correct: 1,
        explanation: '「本心」指人天生具有的善良道德本性，是每個人都有的捨生取義之心。',
        points: 10
      },
      {
        id: 3,
        question: '孟子認為一般人失去本心的主要原因是什麼？',
        type: 'multiple-choice',
        options: [
          '缺乏教育',
          '社會環境不良',
          '受到物質誘惑',
          '天性本惡'
        ],
        correct: 2,
        explanation: '孟子認為人會因為受到物質利益的誘惑而失去本心，但賢者能夠堅持不失。',
        points: 10
      },
      {
        id: 4,
        question: '文中運用了哪種主要的論證方法？',
        type: 'multiple-choice',
        options: [
          '舉例論證',
          '比喻論證',
          '引用論證',
          '歸納論證'
        ],
        correct: 1,
        explanation: '文中主要運用比喻論證，以魚和熊掌比喻生存與道義，使抽象的道理變得具體易懂。',
        points: 10
      },
      {
        id: 5,
        question: '「非禮勿視，非禮勿聽，非禮勿言，非禮勿動」運用了什麼修辭手法？',
        type: 'multiple-choice',
        options: [
          '比喻',
          '排比',
          '對偶',
          '誇張'
        ],
        correct: 1,
        explanation: '這句話運用了排比的修辭手法，四個「非禮勿」的句式整齊，語氣強烈。',
        points: 10
      },
      {
        id: 6,
        question: '孟子寫作此文的主要目的是什麼？',
        type: 'multiple-choice',
        options: [
          '批評社會現象',
          '勸勉人保持善良本心',
          '說明生存的重要性',
          '論述政治理想'
        ],
        correct: 1,
        explanation: '孟子寫作此文的主要目的是勸勉人們應該明辨義利，保持善良的本心，發揚義的善端。',
        points: 10
      },
      {
        id: 7,
        question: '文中「義利之辨」體現了什麼哲學思想？',
        type: 'multiple-choice',
        options: [
          '功利主義',
          '道德理想主義',
          '現實主義',
          '虛無主義'
        ],
        correct: 1,
        explanation: '義利之辨體現了孟子的道德理想主義思想，強調道德品格比物質利益更重要。',
        points: 10
      },
      {
        id: 8,
        question: '孟子認為賢者與一般人的區別在於什麼？',
        type: 'multiple-choice',
        options: [
          '知識水平不同',
          '社會地位不同',
          '能否保持本心',
          '物質條件不同'
        ],
        correct: 2,
        explanation: '孟子認為賢者與一般人的區別在於賢者能夠保持本心不失，而一般人容易失去本心。',
        points: 10
      },
      {
        id: 9,
        question: '文中運用對比論證的效果是什麼？',
        type: 'multiple-choice',
        options: [
          '增加文章篇幅',
          '突出論點的正確性',
          '豐富文章內容',
          '展示作者學識'
        ],
        correct: 1,
        explanation: '對比論證通過正反兩面的對比，更加突出了論點的正確性和重要性。',
        points: 10
      },
      {
        id: 10,
        question: '孟子的「捨生取義」思想對後世產生了什麼影響？',
        type: 'multiple-choice',
        options: [
          '促進了商業發展',
          '影響了中國人的價值觀',
          '改變了政治制度',
          '推動了科技進步'
        ],
        correct: 1,
        explanation: '孟子的捨生取義思想深刻影響了中國人的價值觀，成為中華民族精神品格的重要組成部分。',
        points: 10
      },
      {
        id: 11,
        question: '文中「設問」修辭手法的作用是什麼？',
        type: 'multiple-choice',
        options: [
          '增加文章的神秘感',
          '引起讀者思考',
          '顯示作者的疑惑',
          '增加文章長度'
        ],
        correct: 1,
        explanation: '設問修辭手法能夠引起讀者的思考，使論證更加深入人心。',
        points: 10
      },
      {
        id: 12,
        question: '孟子的論證方式體現了什麼特點？',
        type: 'multiple-choice',
        options: [
          '抽象深奧',
          '生動形象',
          '枯燥乏味',
          '複雜難懂'
        ],
        correct: 1,
        explanation: '孟子善於運用比喻、對比等手法，使抽象的哲學道理變得生動形象，容易理解。',
        points: 10
      }
    ]
  },

  // A2. 荀子《勸學》
  {
    id: 'hkdse-quiz-a2-xunzi-learning',
    textId: 'hkdse-a2-xunzi-learning',
    title: '荀子《勸學》- 測驗',
    category: '議論散文',
    description: '測試對荀子學習思想和論證技巧的理解',
    difficulty: 'intermediate',
    totalQuestions: 10,
    timeLimit: 600, // 10 minutes
    questions: [
      {
        id: 1,
        question: '荀子在文中提出的中心論點是什麼？',
        type: 'multiple-choice',
        options: [
          '學習需要天賦',
          '學不可以已',
          '學習要有方法',
          '學習要有老師'
        ],
        correct: 1,
        explanation: '荀子提出的中心論點是「學不可以已」，即學習是不可以停止的。',
        points: 10
      },
      {
        id: 2,
        question: '荀子認為學習的主要作用是什麼？',
        type: 'multiple-choice',
        options: [
          '獲得知識',
          '改變人的本質',
          '提高社會地位',
          '獲得財富'
        ],
        correct: 1,
        explanation: '荀子認為後天學習能夠改變人的本質，這是學習的根本作用。',
        points: 10
      },
      {
        id: 3,
        question: '文中「青，取之於藍，而青於藍」說明了什麼道理？',
        type: 'multiple-choice',
        options: [
          '學生可以超越老師',
          '顏色的變化規律',
          '學習能夠改變本質',
          '自然界的奧秘'
        ],
        correct: 2,
        explanation: '這個比喻說明了學習能夠改變人的本質，通過學習可以超越原有的水平。',
        points: 10
      },
      {
        id: 4,
        question: '荀子強調學習態度應該是什麼？',
        type: 'multiple-choice',
        options: [
          '隨意學習',
          '專心致志',
          '快速學習',
          '輕鬆學習'
        ],
        correct: 1,
        explanation: '荀子強調學習要專心致志，不斷積累，才能突破自己的限制。',
        points: 10
      },
      {
        id: 5,
        question: '文中運用了大量的什麼修辭手法？',
        type: 'multiple-choice',
        options: [
          '比喻',
          '擬人',
          '誇張',
          '反問'
        ],
        correct: 0,
        explanation: '文中運用了大量的比喻修辭手法，如「青出於藍」、「冰水為之」等。',
        points: 10
      },
      {
        id: 6,
        question: '荀子認為不學習的後果是什麼？',
        type: 'multiple-choice',
        options: [
          '知識不足',
          '一事無成',
          '被人瞧不起',
          '生活困難'
        ],
        correct: 1,
        explanation: '荀子認為如果不專心學習，不斷積累，就會一事無成。',
        points: 10
      },
      {
        id: 7,
        question: '文中「積土成山，風雨興焉」運用了什麼論證方法？',
        type: 'multiple-choice',
        options: [
          '舉例論證',
          '比喻論證',
          '對比論證',
          '引用論證'
        ],
        correct: 1,
        explanation: '這句話運用了比喻論證，以積土成山比喻學習需要不斷積累。',
        points: 10
      },
      {
        id: 8,
        question: '荀子的學習觀體現了什麼哲學思想？',
        type: 'multiple-choice',
        options: [
          '天賦決定論',
          '後天努力論',
          '環境決定論',
          '命運決定論'
        ],
        correct: 1,
        explanation: '荀子的學習觀體現了後天努力論，認為通過後天的學習努力可以改變人的本質。',
        points: 10
      },
      {
        id: 9,
        question: '文中「對偶」修辭手法的作用是什麼？',
        type: 'multiple-choice',
        options: [
          '增加文章的音韻美',
          '使論證更加嚴密',
          '展示作者的才華',
          '增加文章篇幅'
        ],
        correct: 0,
        explanation: '對偶修辭手法能夠增加文章的音韻美，使文章讀起來朗朗上口。',
        points: 10
      },
      {
        id: 10,
        question: '荀子《勸學》對現代教育的啟示是什麼？',
        type: 'multiple-choice',
        options: [
          '學習要有天賦',
          '終身學習的重要性',
          '學習要快速',
          '學習要輕鬆'
        ],
        correct: 1,
        explanation: '荀子《勸學》強調學習不可停止，這對現代教育提出了終身學習的重要啟示。',
        points: 10
      }
    ]
  },

  // B1. 論語論仁
  {
    id: 'hkdse-quiz-b1-analects-ren',
    textId: 'hkdse-b1-analects-ren',
    title: '《論語》論仁 - 測驗',
    category: '語錄體',
    description: '測試對儒家仁學思想和語錄體特色的理解',
    difficulty: 'intermediate',
    totalQuestions: 8,
    timeLimit: 480, // 8 minutes
    questions: [
      {
        id: 1,
        question: '孔子提出的「仁」的核心內容是什麼？',
        type: 'multiple-choice',
        options: [
          '愛人',
          '克己復禮',
          '忠恕',
          '以上都是'
        ],
        correct: 3,
        explanation: '孔子的「仁」包含愛人、克己復禮、忠恕等多重內容，是一個綜合的道德概念。',
        points: 12
      },
      {
        id: 2,
        question: '「克己復禮」中的「克己」是什麼意思？',
        type: 'multiple-choice',
        options: [
          '戰勝敵人',
          '克制自己',
          '努力學習',
          '堅持原則'
        ],
        correct: 1,
        explanation: '「克己」指克制自己的私慾，使自己的行為符合禮法的要求。',
        points: 12
      },
      {
        id: 3,
        question: '「非禮勿視，非禮勿聽，非禮勿言，非禮勿動」體現了什麼？',
        type: 'multiple-choice',
        options: [
          '仁的具體要求',
          '禮的重要性',
          '自我修養的方法',
          '以上都是'
        ],
        correct: 3,
        explanation: '這句話全面體現了仁的具體要求、禮的重要性和自我修養的方法。',
        points: 12
      },
      {
        id: 4,
        question: '孔子認為仁者的態度應該是什麼？',
        type: 'multiple-choice',
        options: [
          '隨機應變',
          '安於實行仁德',
          '追求利益',
          '明哲保身'
        ],
        correct: 1,
        explanation: '孔子認為仁者應該安於實行仁德，無論在任何時候都不會違背仁德。',
        points: 12
      },
      {
        id: 5,
        question: '語錄體的主要特點是什麼？',
        type: 'multiple-choice',
        options: [
          '篇幅長大',
          '結構嚴密',
          '簡潔精煉',
          '華麗辭藻'
        ],
        correct: 2,
        explanation: '語錄體的主要特點是簡潔精煉，用簡短的語言表達深刻的思想。',
        points: 12
      },
      {
        id: 6,
        question: '《論語》中的「排比」修辭手法有什麼作用？',
        type: 'multiple-choice',
        options: [
          '增強語言的氣勢',
          '使內容更加全面',
          '便於記憶',
          '以上都是'
        ],
        correct: 3,
        explanation: '排比修辭手法能夠增強語言氣勢，使內容更加全面，也便於記憶。',
        points: 12
      },
      {
        id: 7,
        question: '孔子的「仁」學思想對中國文化的影響是什麼？',
        type: 'multiple-choice',
        options: [
          '成為中華文化的核心',
          '影響了中國人的道德觀',
          '塑造了中國人的人格理想',
          '以上都是'
        ],
        correct: 3,
        explanation: '孔子的仁學思想成為中華文化的核心，深刻影響了中國人的道德觀和人格理想。',
        points: 12
      },
      {
        id: 8,
        question: '「仁者不憂」說明了什麼？',
        type: 'multiple-choice',
        options: [
          '仁者沒有煩惱',
          '仁者內心平靜',
          '仁者品格高尚',
          '仁者心胸開闊'
        ],
        correct: 1,
        explanation: '「仁者不憂」說明仁者因為品格高尚，內心平靜，不會為外物所困擾。',
        points: 12
      }
    ]
  },

  // C1. 廉頗藺相如列傳
  {
    id: 'hkdse-quiz-c1-sima-lianpo',
    textId: 'hkdse-c1-simaqian-lianpo-linxiangru',
    title: '《廉頗藺相如列傳》- 測驗',
    category: '人物傳記',
    description: '測試對史傳文學和人物刻畫技巧的理解',
    difficulty: 'advanced',
    totalQuestions: 15,
    timeLimit: 900, // 15 minutes
    questions: [
      {
        id: 1,
        question: '《廉頗藺相如列傳》共記述了幾個主要故事？',
        type: 'multiple-choice',
        options: [
          '兩個',
          '三個',
          '四個',
          '五個'
        ],
        correct: 1,
        explanation: '文章記述了「完璧歸趙」、「澠池之會」、「負荊請罪」三個主要故事。',
        points: 8
      },
      {
        id: 2,
        question: '「完璧歸趙」主要表現了藺相如的什麼品格？',
        type: 'multiple-choice',
        options: [
          '機智勇敢',
          '忠心愛國',
          '能言善辯',
          '以上都是'
        ],
        correct: 3,
        explanation: '「完璧歸趙」全面表現了藺相如機智勇敢、忠心愛國、能言善辯的品格。',
        points: 8
      },
      {
        id: 3,
        question: '「澠池之會」中藺相如的表現說明了什麼？',
        type: 'multiple-choice',
        options: [
          '他很有勇氣',
          '他維護了國家尊嚴',
          '他很聰明',
          '他很有口才'
        ],
        correct: 1,
        explanation: '「澠池之會」中藺相如冒死維護趙王和國家的尊嚴，表現出高度的愛國精神。',
        points: 8
      },
      {
        id: 4,
        question: '廉頗「負荊請罪」體現了他什麼品格？',
        type: 'multiple-choice',
        options: [
          '勇於認錯',
          '顧全大局',
          '知錯能改',
          '以上都是'
        ],
        correct: 3,
        explanation: '廉頗負荊請罪體現了他勇於認錯、顧全大局、知錯能改的高尚品格。',
        points: 8
      },
      {
        id: 5,
        question: '司馬遷刻畫人物主要運用了什麼手法？',
        type: 'multiple-choice',
        options: [
          '語言描寫',
          '動作描寫',
          '心理描寫',
          '以上都是'
        ],
        correct: 3,
        explanation: '司馬遷運用了語言描寫、動作描寫、心理描寫等多種手法來刻畫人物。',
        points: 8
      },
      {
        id: 6,
        question: '文中運用對比手法的目的是什麼？',
        type: 'multiple-choice',
        options: [
          '增加故事的戲劇性',
          '突出人物的品格',
          '豐富文章內容',
          '展示寫作技巧'
        ],
        correct: 1,
        explanation: '文中運用對比手法主要是為了突出人物的品格特徵，如藺相如與秦王的對比。',
        points: 8
      },
      {
        id: 7,
        question: '藺相如「先國家之急而後私仇」體現了什麼精神？',
        type: 'multiple-choice',
        options: [
          '愛國主義精神',
          '集體主義精神',
          '顧全大局的精神',
          '以上都是'
        ],
        correct: 3,
        explanation: '這句話體現了藺相如的愛國主義精神、集體主義精神和顧全大局的精神。',
        points: 8
      },
      {
        id: 8,
        question: '史傳文學的特點是什麼？',
        type: 'multiple-choice',
        options: [
          '真實性',
          '文學性',
          '教育性',
          '以上都是'
        ],
        correct: 3,
        explanation: '史傳文學具有真實性、文學性和教育性的特點，既記錄歷史又具有文學價值。',
        points: 8
      },
      {
        id: 9,
        question: '文中「側面描寫」的作用是什麼？',
        type: 'multiple-choice',
        options: [
          '豐富故事情節',
          '烘托人物形象',
          '增加文章篇幅',
          '展示作者才華'
        ],
        correct: 1,
        explanation: '側面描寫通過他人的反應和評價來烘托主要人物的形象，使人物更加立體。',
        points: 8
      },
      {
        id: 10,
        question: '三個故事之間的關係是什麼？',
        type: 'multiple-choice',
        options: [
          '並列關係',
          '遞進關係',
          '對比關係',
          '因果關係'
        ],
        correct: 1,
        explanation: '三個故事呈遞進關係，逐步深化了對人物品格的刻畫。',
        points: 8
      },
      {
        id: 11,
        question: '司馬遷寫作此文的目的是什麼？',
        type: 'multiple-choice',
        options: [
          '記錄歷史事件',
          '歌頌英雄人物',
          '教育後世',
          '以上都是'
        ],
        correct: 3,
        explanation: '司馬遷寫作此文既要記錄歷史，又要歌頌英雄，同時教育後世。',
        points: 8
      },
      {
        id: 12,
        question: '文中人物對話的特點是什麼？',
        type: 'multiple-choice',
        options: [
          '符合人物身份',
          '推動情節發展',
          '展現人物性格',
          '以上都是'
        ],
        correct: 3,
        explanation: '文中人物對話既符合人物身份，又推動情節發展，同時展現人物性格。',
        points: 8
      },
      {
        id: 13,
        question: '「完璧歸趙」中秦王的形象特點是什麼？',
        type: 'multiple-choice',
        options: [
          '貪婪狡詐',
          '霸道蠻橫',
          '色厲內荏',
          '以上都是'
        ],
        correct: 3,
        explanation: '秦王的形象特點是貪婪狡詐、霸道蠻橫、色厲內荏，形成了鮮明的反面形象。',
        points: 8
      },
      {
        id: 14,
        question: '文章的主題思想是什麼？',
        type: 'multiple-choice',
        options: [
          '歌頌愛國主義精神',
          '讚美高尚品格',
          '提倡團結合作',
          '以上都是'
        ],
        correct: 3,
        explanation: '文章的主題思想包括歌頌愛國主義精神、讚美高尚品格、提倡團結合作等。',
        points: 8
      },
      {
        id: 15,
        question: '這篇文章對後世的影響是什麼？',
        type: 'multiple-choice',
        options: [
          '成為史學典範',
          '影響文學創作',
          '教育意義深遠',
          '以上都是'
        ],
        correct: 3,
        explanation: '這篇文章成為史學典範，影響了後世的文學創作，具有深遠的教育意義。',
        points: 8
      }
    ]
  },

  // D1. 岳陽樓記
  {
    id: 'hkdse-quiz-d1-fan-yueyang',
    textId: 'hkdse-d1-fanzhongyan-yueyanglou-ji',
    title: '《岳陽樓記》- 測驗',
    category: '抒情遊記',
    description: '測試對借景抒情手法和憂樂觀的理解',
    difficulty: 'advanced',
    totalQuestions: 12,
    timeLimit: 720, // 12 minutes
    questions: [
      {
        id: 1,
        question: '范仲淹寫作《岳陽樓記》的直接原因是什麼？',
        type: 'multiple-choice',
        options: [
          '遊覽岳陽樓',
          '應滕子京之請',
          '抒發個人情懷',
          '記錄歷史事件'
        ],
        correct: 1,
        explanation: '范仲淹是應好友滕子京之請而寫作《岳陽樓記》的。',
        points: 10
      },
      {
        id: 2,
        question: '文中「先天下之憂而憂，後天下之樂而樂」體現了什麼思想？',
        type: 'multiple-choice',
        options: [
          '個人主義',
          '憂國憂民',
          '享樂主義',
          '消極避世'
        ],
        correct: 1,
        explanation: '這句話體現了范仲淹憂國憂民、以天下為己任的崇高思想境界。',
        points: 10
      },
      {
        id: 3,
        question: '文中描寫洞庭湖陰雨天氣的目的是什麼？',
        type: 'multiple-choice',
        options: [
          '展示自然景觀',
          '烘托悲涼氣氛',
          '對比晴天美景',
          '以上都是'
        ],
        correct: 3,
        explanation: '描寫陰雨天氣既展示了自然景觀，又烘托了悲涼氣氛，同時與晴天美景形成對比。',
        points: 10
      },
      {
        id: 4,
        question: '「遷客騷人」指的是什麼人？',
        type: 'multiple-choice',
        options: [
          '遊客和詩人',
          '被貶官員和文人',
          '商人和學者',
          '農民和工匠'
        ],
        correct: 1,
        explanation: '「遷客騷人」指被貶謫的官員和憂愁的文人。',
        points: 10
      },
      {
        id: 5,
        question: '文中運用了什麼主要的表現手法？',
        type: 'multiple-choice',
        options: [
          '借景抒情',
          '託物言志',
          '對比襯托',
          '以上都是'
        ],
        correct: 3,
        explanation: '文中運用了借景抒情、託物言志、對比襯托等多種表現手法。',
        points: 10
      },
      {
        id: 6,
        question: '「浩浩湯湯，橫無際涯」運用了什麼修辭手法？',
        type: 'multiple-choice',
        options: [
          '比喻',
          '誇張',
          '對偶',
          '疊字'
        ],
        correct: 3,
        explanation: '「浩浩湯湯」運用了疊字的修辭手法，增強了語言的音韻美。',
        points: 10
      },
      {
        id: 7,
        question: '古代仁人的特點是什麼？',
        type: 'multiple-choice',
        options: [
          '不以物喜，不以己悲',
          '先憂後樂',
          '品格高尚',
          '以上都是'
        ],
        correct: 3,
        explanation: '古代仁人具有不以物喜不以己悲、先憂後樂、品格高尚等特點。',
        points: 10
      },
      {
        id: 8,
        question: '范仲淹寫作此文的深層用意是什麼？',
        type: 'multiple-choice',
        options: [
          '記錄遊覽經歷',
          '勉勵滕子京',
          '抒發政治理想',
          '展示文學才華'
        ],
        correct: 1,
        explanation: '范仲淹寫作此文的深層用意是勉勵同樣被貶的好友滕子京，要有先憂後樂的胸懷。',
        points: 10
      },
      {
        id: 9,
        question: '文中對比手法的運用體現在哪些方面？',
        type: 'multiple-choice',
        options: [
          '陰雨與晴天的對比',
          '悲與喜的對比',
          '一般人與仁人的對比',
          '以上都是'
        ],
        correct: 3,
        explanation: '文中運用了多層次的對比，包括天氣、情感、人物品格等方面的對比。',
        points: 10
      },
      {
        id: 10,
        question: '「微斯人，吾誰與歸」表達了什麼情感？',
        type: 'multiple-choice',
        options: [
          '孤獨寂寞',
          '尋求知音',
          '政治理想',
          '以上都是'
        ],
        correct: 3,
        explanation: '這句話表達了作者的孤獨寂寞、尋求知音的情感，同時也體現了政治理想。',
        points: 10
      },
      {
        id: 11,
        question: '文章的結構特點是什麼？',
        type: 'multiple-choice',
        options: [
          '記敘-描寫-議論-抒情',
          '時間順序',
          '空間順序',
          '邏輯順序'
        ],
        correct: 0,
        explanation: '文章採用記敘-描寫-議論-抒情的結構，層層遞進，最後點明主題。',
        points: 10
      },
      {
        id: 12,
        question: '《岳陽樓記》的現實意義是什麼？',
        type: 'multiple-choice',
        options: [
          '提倡憂國憂民精神',
          '樹立正確的人生觀',
          '弘揚傳統文化',
          '以上都是'
        ],
        correct: 3,
        explanation: '《岳陽樓記》具有提倡憂國憂民精神、樹立正確人生觀、弘揚傳統文化等現實意義。',
        points: 10
      }
    ]
  },

  // F1. 唐詩三首
  {
    id: 'hkdse-quiz-f1-tang-poems',
    textId: 'hkdse-f1-tangshi-sanzhou',
    title: '唐詩三首 - 測驗',
    category: '詩詞',
    description: '測試對唐詩藝術特色和情感表達的理解',
    difficulty: 'intermediate',
    totalQuestions: 15,
    timeLimit: 900, // 15 minutes
    questions: [
      {
        id: 1,
        question: '王維《山居秋暝》表達了什麼情感？',
        type: 'multiple-choice',
        options: [
          '對隱居生活的嚮往',
          '對自然美景的讚美',
          '對淳樸生活的嚮往',
          '以上都是'
        ],
        correct: 3,
        explanation: '王維《山居秋暝》表達了對隱居生活的嚮往、對自然美景的讚美和對淳樸生活的嚮往。',
        points: 8
      },
      {
        id: 2,
        question: '李白《月下獨酌》的主要情感是什麼？',
        type: 'multiple-choice',
        options: [
          '孤單落寞',
          '鬱悶不快',
          '缺少知己',
          '以上都是'
        ],
        correct: 3,
        explanation: '李白《月下獨酌》表達了孤單落寞、鬱悶不快、缺少知己的複雜情感。',
        points: 8
      },
      {
        id: 3,
        question: '杜甫《登樓》體現了什麼思想感情？',
        type: 'multiple-choice',
        options: [
          '憂國憂民',
          '懷才不遇',
          '愛國情懷',
          '以上都是'
        ],
        correct: 3,
        explanation: '杜甫《登樓》體現了憂國憂民、懷才不遇的無奈和深沉的愛國情懷。',
        points: 8
      },
      {
        id: 4,
        question: '王維詩歌的藝術特色是什麼？',
        type: 'multiple-choice',
        options: [
          '詩中有畫',
          '意境深遠',
          '清新自然',
          '以上都是'
        ],
        correct: 3,
        explanation: '王維詩歌具有詩中有畫、意境深遠、清新自然的藝術特色。',
        points: 8
      },
      {
        id: 5,
        question: '李白詩歌的風格特點是什麼？',
        type: 'multiple-choice',
        options: [
          '豪邁奔放',
          '想象豐富',
          '情感真摯',
          '以上都是'
        ],
        correct: 3,
        explanation: '李白詩歌具有豪邁奔放、想象豐富、情感真摯的風格特點。',
        points: 8
      },
      {
        id: 6,
        question: '杜甫詩歌的特色是什麼？',
        type: 'multiple-choice',
        options: [
          '沉鬱頓挫',
          '憂國憂民',
          '現實主義',
          '以上都是'
        ],
        correct: 3,
        explanation: '杜甫詩歌具有沉鬱頓挫、憂國憂民、現實主義的特色。',
        points: 8
      },
      {
        id: 7,
        question: '唐詩的體例特點是什麼？',
        type: 'multiple-choice',
        options: [
          '格律嚴謹',
          '平仄協調',
          '對仗工整',
          '以上都是'
        ],
        correct: 3,
        explanation: '唐詩具有格律嚴謹、平仄協調、對仗工整的體例特點。',
        points: 8
      },
      {
        id: 8,
        question: '「明月松間照，清泉石上流」運用了什麼表現手法？',
        type: 'multiple-choice',
        options: [
          '動靜結合',
          '視聽結合',
          '色彩搭配',
          '以上都是'
        ],
        correct: 3,
        explanation: '這句詩運用了動靜結合、視聽結合、色彩搭配等多種表現手法。',
        points: 8
      },
      {
        id: 9,
        question: '「舉杯邀明月，對影成三人」體現了什麼？',
        type: 'multiple-choice',
        options: [
          '想象的奇特',
          '情感的孤獨',
          '浪漫的情懷',
          '以上都是'
        ],
        correct: 3,
        explanation: '這句詩體現了李白想象的奇特、情感的孤獨和浪漫的情懷。',
        points: 8
      },
      {
        id: 10,
        question: '「花近高樓傷客心」中的「傷」字有什麼表達效果？',
        type: 'multiple-choice',
        options: [
          '點明情感基調',
          '突出內心痛苦',
          '呼應全詩主題',
          '以上都是'
        ],
        correct: 3,
        explanation: '「傷」字點明了情感基調，突出了內心痛苦，呼應了全詩主題。',
        points: 8
      },
      {
        id: 11,
        question: '唐詩中的「借景抒情」手法有什麼作用？',
        type: 'multiple-choice',
        options: [
          '使情感更加真切',
          '增強藝術感染力',
          '豐富詩歌內涵',
          '以上都是'
        ],
        correct: 3,
        explanation: '借景抒情手法能使情感更加真切，增強藝術感染力，豐富詩歌內涵。',
        points: 8
      },
      {
        id: 12,
        question: '三位詩人的共同特點是什麼？',
        type: 'multiple-choice',
        options: [
          '都是唐代詩人',
          '都有高超的藝術技巧',
          '都有深厚的文學造詣',
          '以上都是'
        ],
        correct: 3,
        explanation: '三位詩人都是唐代詩人，都有高超的藝術技巧和深厚的文學造詣。',
        points: 8
      },
      {
        id: 13,
        question: '唐詩的意境營造主要通過什麼實現？',
        type: 'multiple-choice',
        options: [
          '景物描寫',
          '情感抒發',
          '想象聯想',
          '以上都是'
        ],
        correct: 3,
        explanation: '唐詩的意境營造主要通過景物描寫、情感抒發、想象聯想等方式實現。',
        points: 8
      },
      {
        id: 14,
        question: '學習唐詩的意義是什麼？',
        type: 'multiple-choice',
        options: [
          '提高文學素養',
          '陶冶情操',
          '傳承文化',
          '以上都是'
        ],
        correct: 3,
        explanation: '學習唐詩能夠提高文學素養、陶冶情操、傳承文化。',
        points: 8
      },
      {
        id: 15,
        question: '唐詩對後世文學的影響是什麼？',
        type: 'multiple-choice',
        options: [
          '樹立了詩歌典範',
          '影響了創作風格',
          '豐富了表達技巧',
          '以上都是'
        ],
        correct: 3,
        explanation: '唐詩樹立了詩歌典範，影響了後世的創作風格，豐富了表達技巧。',
        points: 8
      }
    ]
  }
];

// 測驗統計數據
export const hkdseQuizStats = {
  totalQuizzes: hkdseQuizzes.length,
  totalQuestions: hkdseQuizzes.reduce((sum, quiz) => sum + quiz.totalQuestions, 0),
  averageTimePerQuiz: Math.round(hkdseQuizzes.reduce((sum, quiz) => sum + quiz.timeLimit, 0) / hkdseQuizzes.length / 60),
  difficultyDistribution: {
    beginner: hkdseQuizzes.filter(quiz => quiz.difficulty === 'beginner').length,
    intermediate: hkdseQuizzes.filter(quiz => quiz.difficulty === 'intermediate').length,
    advanced: hkdseQuizzes.filter(quiz => quiz.difficulty === 'advanced').length
  },
  categoryDistribution: hkdseQuizzes.reduce((acc, quiz) => {
    acc[quiz.category] = (acc[quiz.category] || 0) + 1;
    return acc;
  }, {})
};

// 獲取特定文本的測驗
export const getHKDSEQuizByTextId = (textId) => {
  return hkdseQuizzes.find(quiz => quiz.textId === textId);
};

// 獲取特定類別的測驗
export const getHKDSEQuizzesByCategory = (category) => {
  return hkdseQuizzes.filter(quiz => quiz.category === category);
};

// 獲取特定難度的測驗
export const getHKDSEQuizzesByDifficulty = (difficulty) => {
  return hkdseQuizzes.filter(quiz => quiz.difficulty === difficulty);
};

// 測驗結果評分標準（沿用原有的評分系統）
export const hkdseGradingScale = {
  excellent: { min: 90, max: 100, label: '優秀', color: 'text-green-600', bgColor: 'bg-green-100' },
  good: { min: 80, max: 89, label: '良好', color: 'text-blue-600', bgColor: 'bg-blue-100' },
  satisfactory: { min: 70, max: 79, label: '及格', color: 'text-yellow-600', bgColor: 'bg-yellow-100' },
  needsImprovement: { min: 0, max: 69, label: '需要改進', color: 'text-red-600', bgColor: 'bg-red-100' }
};

// 獲取成績等級
export const getHKDSEGradeLevel = (score) => {
  for (const [key, grade] of Object.entries(hkdseGradingScale)) {
    if (score >= grade.min && score <= grade.max) {
      return { key, ...grade };
    }
  }
  return hkdseGradingScale.needsImprovement;
};

// HKDSE 學習建議
export const getHKDSEStudyRecommendations = (score, category) => {
  const gradeLevel = getHKDSEGradeLevel(score);
  
  const recommendations = {
    excellent: [
      '恭喜！您對這篇範文的掌握非常好。',
      '建議深入研究相關的文學背景和寫作技巧。',
      '可以嘗試分析其他同類型的文學作品。',
      '準備挑戰更高難度的文學理解題目。'
    ],
    good: [
      '您的基礎很扎實，還有進步空間。',
      '建議重點複習論證手法和修辭技巧。',
      '多做相關的練習題鞏固知識。',
      '注意文本細節的理解和分析。'
    ],
    satisfactory: [
      '基本概念掌握得還可以。',
      '建議重新閱讀原文，加深理解。',
      '重點複習主旨和考核重點。',
      '多參考相關的學習資料和注釋。'
    ],
    needsImprovement: [
      '需要加強對這篇範文的理解。',
      '建議先熟讀原文，理解基本內容。',
      '可以請教老師或同學。',
      '需要系統地學習相關的文學知識。'
    ]
  };
  
  return recommendations[gradeLevel.key] || recommendations.needsImprovement;
}; 